import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function ProtectedRoute({ children, roles, menuKey, superAdminOnly }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="h-screen flex items-center justify-center text-slate-500">
        Carregando…
      </div>
    );
  if (!user) {
    // /super-admin/* and platform routes head to the dedicated platform portal.
    const isPlatform = loc.pathname.startsWith("/super-admin");
    return (
      <Navigate
        to={isPlatform ? "/platform/login" : "/login"}
        state={{ from: loc }}
        replace
      />
    );
  }
  if (roles && !roles.includes(user.role))
    return <Navigate to="/dashboard" replace />;
  // Hard-block: only super-admins can touch /super-admin/*. Otherwise send to portal.
  if (loc.pathname.startsWith("/super-admin") && !user.is_super_admin) {
    return <Navigate to="/platform/login" replace />;
  }
  // Routes marked as superAdminOnly (e.g. /billing) ficam invisíveis ao admin
  // de tenant — só o operador da plataforma acessa.
  if (superAdminOnly && !user.is_super_admin) {
    return <Navigate to="/dashboard" replace />;
  }
  // Super-admins ignore disabled_menus and always have access.
  if (
    menuKey &&
    !user.is_super_admin &&
    Array.isArray(user.disabled_menus) &&
    user.disabled_menus.includes(menuKey)
  ) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
